import { Letter } from 'state/letter/types'

import { CellProps } from 'components/ui'

import { Wrapper, Title, Value } from '../Style'

export function Email({ row }: CellProps<Letter>) {
  const { email } = row.original

  return (
    <Wrapper area='Email'>
      <Title>Email</Title>
      <Value>{email}</Value>
    </Wrapper>
  )
}
